/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Home_Editor_StartInputs */

const en_wc_home_editor_start = /** @type {(inputs: Wc_Home_Editor_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try WordCraft here`)
};

/**
* | output |
* | --- |
* | "Try WordCraft here" |
*
* @param {Wc_Home_Editor_StartInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_home_editor_start = /** @type {((inputs?: Wc_Home_Editor_StartInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Home_Editor_StartInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_home_editor_start(inputs)
});
export { wc_home_editor_start as "wc.home.editor_start" }